export const CellIds = {
  default: 'ag-cell',
  header: 'header',
  numeric: 'ag-right-aligned-cell',
  string: 'stringType',
};

export const ColumnTypes = {
  numeric: 'numericColumn',
};

export const DataTypes = {
  string: 'String',
  number: 'Number',
};

export const ACCOUNTS_GRID = 'ACCOUNTS';
export const GROUPS_GRID = 'GROUPS';
export const JOURNALS_GRID = 'JOURNALS`';
export const KPIS_GRID = 'KPIS';

export const SortingOrder = {
  ASC: 'ASC',
  DESC: 'DESC',
};
